import api, { unwrapList } from './api';
const notificationService = {
  getAll:   ()   => api.get('/notifications/').then(r => unwrapList(r.data)),
  markRead: (id) => api.patch(`/notifications/${id}/read/`).then(r => r.data),
  markAllRead: () => api.post('/notifications/read-all/').then(r => r.data),
};
export default notificationService;